// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collect_container__\\+Q61J {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: #fff;
}

.collect_main__YAqzd {
    width: 100%;
    height: 100%;
}

.collect_header__4DbnT {

}

.collect_title_box__SQtrl {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 50px;
    margin-bottom: 100px;
}

.collect_title__7I26y {
    font-size: 38px;
    font-weight: bold;
    color: #262626;
}

.collect_filter_box__\\+J\\+Vg {
    width: 50%;
    height: calc(43px + 16px + 33px);    /* calc(43px + 16px + 33px) = 92px */
    margin: 0 auto;
    margin-bottom: 16px;
}

.collect_content_box__bMEAo {
    display: flex;
    justify-content: center;
    width: 100%;
    height: calc(100% - 53px - 150px - 91px - 16px);
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.collect_content_box__bMEAo::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
}

.collect_content_box__bMEAo::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.collect_content_box__bMEAo::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.collect_show_box__HmIa5 {
    width: calc(50% + 5px);
    margin-right: -10px;
}

.collect_none_box__DYZqb {
    width: 100%;
    height: calc(100% - 100px);
}`, "",{"version":3,"sources":["webpack://./src/pages/collect/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,gCAAgC,KAAK,oCAAoC;IACzE,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,+CAA+C;IAC/C,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,gDAAiC,UAAU;IACvC,wBAAwB;IACxB,WAAW;IACX,YAAY;AAChB;;AAEA,sDAAuC,WAAW;IAC9C,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B","sourcesContent":[".container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    background-color: #fff;\n}\n\n.main {\n    width: 100%;\n    height: 100%;\n}\n\n.header {\n\n}\n\n.title_box {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    height: 50px;\n    margin-bottom: 100px;\n}\n\n.title {\n    font-size: 38px;\n    font-weight: bold;\n    color: #262626;\n}\n\n.filter_box {\n    width: 50%;\n    height: calc(43px + 16px + 33px);    /* calc(43px + 16px + 33px) = 92px */\n    margin: 0 auto;\n    margin-bottom: 16px;\n}\n\n.content_box {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    height: calc(100% - 53px - 150px - 91px - 16px);\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.content_box::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 10px;\n    height: 10px;\n}\n\n.content_box::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.content_box::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.show_box {\n    width: calc(50% + 5px);\n    margin-right: -10px;\n}\n\n.none_box {\n    width: 100%;\n    height: calc(100% - 100px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `collect_container__+Q61J`,
	"main": `collect_main__YAqzd`,
	"header": `collect_header__4DbnT`,
	"title_box": `collect_title_box__SQtrl`,
	"title": `collect_title__7I26y`,
	"filter_box": `collect_filter_box__+J+Vg`,
	"content_box": `collect_content_box__bMEAo`,
	"show_box": `collect_show_box__HmIa5`,
	"none_box": `collect_none_box__DYZqb`
};
export default ___CSS_LOADER_EXPORT___;
